import "@lottiefiles/lottie-player";

import lax from "lax.js";
window.onload = () => {

    window.lax = { presets: lax.presets }
    lax.init();
    lax.addDriver('scrollY', function () {
        return window.scrollY
    });

    lax.addElements(".hero-title", {
        scrollY: {
            scale: [
                [0, 100],
                [1, 0.85],
            ],
            translateY: [
                [0, 100], {
                    500: [0, 20], // Screen width < 500
                    1500: [0, 70], // Screen width > 500 and < 1500
                    1800: [0, 70], // Screen width > 900
                },

            ],
        },
    });

    lax.addElements(".hero", {
        scrollY: {
            scale: [
                ['elInY', 'elCenterY', 'elOutY'], {
                    500: [1, 1, 0.65], // Screen width < 500
                    1500: [1, 1, 0.5], // Screen width > 500 and < 1500
                    1800: [1, 1, 0.5], // Screen width > 900
                },
            ],
        },
    });

    lax.addElements(".left-contact", {
        scrollY: {
            translateY: [
                ['elInY', 'elCenterY', 'elOutY'], {
                    500: [0, 0, -50], // Screen width < 500
                    900: [0, 0, -100], // Screen width > 500 and < 900
                    1400: [0, 0, -400], // Screen width > 900
                },
            ],
        },
    });

    lax.addElements(".movin-obj", {
        scrollY: {
            translateX: [
                ['elInY', 'elCenterY', 'elOutY'],
                ['-screenWidth', 'screenWidth/screenWidth', 'screenWidth'], {
                    easing: "easeInOutQuad"
                }
            ],
            translateY: [
                ['elInY', 'elCenterY', 'elOutY'], {
                    500: [0, 0, 0], // Screen width < 500
                    900: [0, -25, -50], // Screen width > 500 and < 900
                    1400: [0, -50, -100], // Screen width > 900
                }
            ],
        },
    });


    lax.addElements(".propic", {
        scrollY: {
            scale: [
                ['elInY', 'elCenterY', 'elOutY'],
                [0.5, 1, 0.5],
            ],
            rotate: [
                ['elInY', 'elCenterY', 'elOutY-100', 'elOutY'],
                [0, 0, 0, 40],
            ],
        },
    });

    lax.addElements(".about-text", {
        scrollY: {
            scale: [
                ['elInY', 'elOutY-700', 'elOutY-500', 'elOutY'],
                [0.5, 1, 1, 0.3],
            ],
        },
    });

    lax.addElements(".path-text", {
        scrollY: {
            scale: [
                ['elInY', 'elOutY-700', 'elOutY-200', 'elOutY'],
                [0.5, 1, 1, 0.5],
            ],
            translateX: [
                ['elInY', 'elOutY-400', 'elOutY'],
                [0, 0, "screenWidth/7"],
            ]
        },
    });

    lax.addElements(".path-text-left", {
        scrollY: {
            scale: [
                ['elInY', 'elOutY-700', 'elOutY-200', 'elOutY'],
                [0.5, 1, 1, 0.5],
            ],
            translateX: [
                ['elInY', 'elOutY-200', 'elOutY'],
                [0, 0, "-screenWidth/5"],
            ]
        },
    });

    lax.addElements(".service-text", {
        scrollY: {
            scale: [
                ['elInY', 'elOutY-600', 'elOutY-100', 'elOutY'],
                [0.5, 1, 1, 0.5],
            ],
        },
    });

    lax.addElements(".left-service", {
        scrollY: {
            scale: [
                ['elInY', 'elOutY-900', 'elOutY-200', 'elOutY'], {
                    500: [0.1, 1, 1, 0.5], // Screen width < 500
                    1500: [0.7, 1, 1, 0.9],// Screen width > 500 and < 1500
                    1800: [0.7, 1, 1, 0.9],// Screen width > 900
                },

            ],
            translateX: [
                ['elInY', 'elOutY-800', 'elOutY-200', 'elOutY'], {
                    500: [0, 0, 0, 0], // Screen width < 500
                    1500: ["-screenWidth/9", 0, 0, "-screenWidth/5"], // Screen width > 500 and < 1500
                    1800: ["-screenWidth/9", 0, 0, "-screenWidth/5"], // Screen width > 900
                },

            ]
        },
    });

    lax.addElements(".right-service", {
        scrollY: {
            scale: [
                ['elInY', 'elOutY-900', 'elOutY-200', 'elOutY'], {
                    500: [0.1, 1, 1, 0.5], // Screen width < 500
                    1500: [0.7, 1, 1, 0.9],// Screen width > 500 and < 1500
                    1800: [0.7, 1, 1, 0.9],// Screen width > 900
                }
            ],
            translateX: [
                ['elInY', 'elOutY-800', 'elOutY-200', 'elOutY'], {
                    500: [0, 0, 0, 0], // Screen width < 500
                    1500: ["screenWidth/9", 0, 0, "screenWidth/5"], // Screen width > 500 and < 1500
                    1800: ["screenWidth/9", 0, 0, "screenWidth/5"], // Screen width > 900
                },

            ]
        },
    });

    lax.addElements(".center-service", {
        scrollY: {
            scale: [
                ['elInY', 'elOutY-900', 'elOutY-200', 'elOutY'], {
                    500: [0.1, 1, 1, 0.7], // Screen width < 500
                }
            ],
        },
    });

    lax.addElements("#card1", {
        scrollY: {
            scale: [
                ['elInY', 'elOutY-900', 'elOutY-200', 'elOutY'], {
                    500: [0.1, 1, 1, 0.5], // Screen width < 500
                    1500: [0.7, 1, 1, 0.9],// Screen width > 500 and < 1500
                    1800: [0.7, 1, 1, 0.9],// Screen width > 900
                },

            ],
            translateX: [
                ['elInY', 'elOutY-800', 'elOutY-200', 'elOutY'], {
                    500: [0, 0, 0, 0], // Screen width < 500
                    1500: ["-screenWidth/9", 0, 0, "-screenWidth/5"], // Screen width > 500 and < 1500
                    1800: ["-screenWidth/9", 0, 0, "-screenWidth/5"], // Screen width > 900
                },

            ]
        },
    });

    lax.addElements("#card2", {
        scrollY: {
            scale: [
                ['elInY', 'elOutY-900', 'elOutY-200', 'elOutY'], {
                    500: [0.1, 1, 1, 0.7], // Screen width < 500
                }
            ],
        },
    });

    lax.addElements("#card3", {
        scrollY: {
            scale: [
                ['elInY', 'elOutY-900', 'elOutY-200', 'elOutY'], {
                    500: [0.1, 1, 1, 0.5], // Screen width < 500
                    1500: [0.7, 1, 1, 0.9],// Screen width > 500 and < 1500
                    1800: [0.7, 1, 1, 0.9],// Screen width > 900
                }
            ],
            translateX: [
                ['elInY', 'elOutY-800', 'elOutY-200', 'elOutY'], {
                    500: [0, 0, 0, 0], // Screen width < 500
                    1500: ["screenWidth/9", 0, 0, "screenWidth/5"], // Screen width > 500 and < 1500
                    1800: ["screenWidth/9", 0, 0, "screenWidth/5"], // Screen width > 900
                },

            ]
        },
    });

    lax.addElements("#card4", {
        scrollY: {
            scale: [
                ['elInY', 'elOutY-900', 'elOutY-200', 'elOutY'], {
                    500: [0.1, 1, 1, 0.5], // Screen width < 500
                    1500: [0.7, 1, 1, 0.9],// Screen width > 500 and < 1500
                    1800: [0.7, 1, 1, 0.9],// Screen width > 900
                },

            ],
            translateX: [
                ['elInY', 'elOutY-800', 'elOutY-200', 'elOutY'], {
                    500: [0, 0, 0, 0], // Screen width < 500
                    1500: ["-screenWidth/9", 0, 0, "-screenWidth/5"], // Screen width > 500 and < 1500
                    1800: ["-screenWidth/9", 0, 0, "-screenWidth/5"], // Screen width > 900
                },

            ]
        },
    });

    lax.addElements("#card5", {
        scrollY: {
            scale: [
                ['elInY', 'elOutY-900', 'elOutY-200', 'elOutY'], {
                    500: [0.1, 1, 1, 0.7], // Screen width < 500
                }
            ],
        },
    });

    lax.addElements("#card6", {
        scrollY: {
            scale: [
                ['elInY', 'elOutY-900', 'elOutY-200', 'elOutY'], {
                    500: [0.1, 1, 1, 0.5], // Screen width < 500
                    1500: [0.7, 1, 1, 0.9],// Screen width > 500 and < 1500
                    1800: [0.7, 1, 1, 0.9],// Screen width > 900
                }
            ],
            translateX: [
                ['elInY', 'elOutY-800', 'elOutY-200', 'elOutY'], {
                    500: [0, 0, 0, 0], // Screen width < 500
                    1500: ["screenWidth/9", 0, 0, "screenWidth/5"], // Screen width > 500 and < 1500
                    1800: ["screenWidth/9", 0, 0, "screenWidth/5"], // Screen width > 900
                },

            ]
        },
    });

    lax.addElements(".project-text", {
        scrollY: {
            scale: [
                ['elInY', 'elOutY-600', 'elOutY-100', 'elOutY'],
                [0.5, 1, 1, 0.5],
            ],
        },
    });

    lax.addElements(".colab", {
        scrollY: {
            scale: [
                ['elInY', 'elOutY-700', 'elOutY-500', 'elOutY'],
                [0.5, 1, 1, 0.3],
            ],
        },
    });


    document.querySelectorAll(".obj").forEach((o) => {
        let rand1 = Math.floor(Math.random() * (90 - 60 + 1)) + 60;
        let rand2 = Math.floor(Math.random() * (80 - 60 + 1)) + 60;
        o.style.left = rand1 + "vw";
        o.style.top = rand2 + "vh";
    });

    document.querySelectorAll(".obj2").forEach((o) => {
        let rand1 = Math.floor(Math.random() * 100);
        let rand2 = Math.floor(Math.random() * 100);
        o.style.left = rand1 + "vw";
        o.style.top = rand2 + "vh";
    });
};

let lastScrollTop = 0;
window.addEventListener("scroll", function () {
    let st = window.pageYOffset || document.documentElement.scrollTop;
    if (st > lastScrollTop) {
        document.querySelectorAll('.movin-obj-img').forEach((o) => {
            o.style.transform = "rotateY(0deg)";
        })
    } else {
        document.querySelectorAll('.movin-obj-img').forEach((o) => {
            o.style.transform = "rotateY(180deg)";
        })
    }
    lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}, false);